export default __webpack_public_path__ + "static/media/exclamation_mark.03151cf3.svg";